import { Descriptions } from "antd";
import { EnumeratorInterface } from "api/enumerator/Profile/dto";
import { formatDate } from "utils/date";

interface BasicInfoProps {
  user:EnumeratorInterface ; 
}

export const BasicInfo = ({ user }: BasicInfoProps) => (
  <Descriptions
    title="Basic Information"
    layout="vertical"
    column={{ xxl: 4, xl: 4, lg: 4, md: 1, sm: 1, xs: 1 }}
  >
    <Descriptions.Item label="Date of Birth">
      {user?.dateOfBirth ? formatDate(user?.dateOfBirth) : "-"}
    </Descriptions.Item>
    <Descriptions.Item label="Email">{user?.email}</Descriptions.Item>
    <Descriptions.Item label="Phone Number">{user?.phoneNumber}</Descriptions.Item>
    <Descriptions.Item label="Gender">{user?.gender}</Descriptions.Item>
  </Descriptions>
);